const sidebar = {
  section: {
    control: 'Giám sát',
    admin: 'Quản lý',
  },
  myPage: 'Trang của tôi',
  collapse: 'Thu gọn menu',
  expand: 'Mở rộng menu',
  enterprise: {
    title: 'Giám sát toàn công ty',
    dashboard: 'Bảng điều khiển toàn công ty',
    factoryOverview: 'Tình trạng sản xuất theo nhà máy',
    dataflow: 'Luồng thu thập dữ liệu',
  },
  factory: {
    title: 'Giám sát nhà máy',
    overview: 'Tình trạng sản xuất nhà máy',
    machineOverview: 'Tình trạng máy ép phun',
    defectHistory: 'Lịch sử lỗi',
    realtimeShot: 'Tình trạng shot thời gian thực',
  },
  machine: {
    title: 'Giám sát máy ép',
    dashboard: 'Bảng điều khiển máy ép',
    equipmentBoard: 'Bảng trạng thái thiết bị',
  },
  ai: {
    title: 'Phân tích AI',
    analysis: 'Phân tích AI',
    manage: 'Quản lý AI',
    labelReview: 'Duyệt nhãn',
  },
  management: {
    title: 'Quản lý nhà máy/thiết bị',
    factoryList: 'Danh sách nhà máy',
    factoryRegister: 'Đăng ký nhà máy',
    equipmentList: 'Danh sách thiết bị',
    equipmentRegister: 'Đăng ký thiết bị',
  },
  user: {
    title: 'Quản lý thành viên',
    list: 'Danh sách thành viên',
    register: 'Đăng ký thành viên',
    role: 'Quản lý quyền',
    notice: 'Quản lý thông báo',
  },
  system: {
    title: 'Quản lý hệ thống',
    general: 'Cài đặt chung',
    monitoring: 'Cài đặt giám sát',
    alarm: 'Cài đặt cảnh báo',
    dataCollection: 'Quản lý thu thập dữ liệu',
    log: 'Nhật ký hệ thống',
    ip: 'Quản lý IP',
    labeling: 'Gán nhãn Vision',
  },
  moduleb: {
    title: 'Mô-đun B Phán định tổng hợp',
    sync: 'Đồng bộ shot-sản phẩm',
    features: 'Trích xuất & đối sánh đặc trưng',
    fusion: 'Tổng hợp trọng số 3 nguồn',
    judgment: 'Phán định lỗi tổng hợp',
  },
  modulec: {
    title: 'Mô-đun C Quản lý chất lượng tự động',
    recommend: 'Tạo & phê duyệt khuyến nghị',
    safeguard: 'Bảo vệ an toàn',
  },
  platform: {
    title: 'Quản lý nền tảng',
    companies: 'Quản lý công ty',
    users: 'Tất cả người dùng',
    status: 'Trạng thái hệ thống',
    licenses: 'Quản lý giấy phép',
  },
};

export default sidebar;
